import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';

import { Icon } from '../Icon';
import type { CustomIconProps } from './types';

/**
 * Renders an error icon with an optional badge.
 *
 * @see Docs https://fontawesome.com/icons/ellipsis?f=classic&s=solid
 */
export const ErrorIcon: React.FC<CustomIconProps> = (props) => {
  return <Icon icon={faTriangleExclamation} {...props} />;
};
